// extracted by mini-css-extract-plugin
export default {"main":"o5L30","icon":"AAf7L"};